if (!customElements.get('protect-spray-funnel')) {
  let detachedHeaderCart;

  customElements.define('protect-spray-funnel', class extends window.FunnelMiniCartMixin(HTMLElement) {
    connectedCallback() {
      document.body.classList.add('cp-funnel');
      this.currency = window.Shopify?.currency?.active || this.dataset.currency;
      this.packInputs = [...this.querySelectorAll('[data-pack]')];
      this.crossSells = [...this.querySelectorAll('[data-cross-sell]')];
      this.packCta = this.querySelector('[data-pack-cta]');
      this.footerAction = this.querySelector('[data-footer-action]');
      this.checkoutButton = this.querySelector('[data-checkout]');
      this.cartSummary = this.querySelector('[data-cart-summary]');
      this.miniCart = this.querySelector('[data-mini-cart]');
      this.miniCartLines = this.querySelector('[data-mini-cart-lines]');
      this.miniCartClose = this.querySelector('[data-mini-cart-close]');
      this.inlineCart = this.querySelector('[data-inline-cart]');
      this.inlineCartLines = this.querySelector('[data-inline-cart-lines]');
      this.sticky = this.querySelector('[data-sticky]');
      this.desktopBreakpoint = window.matchMedia('(min-width: 1024px)');
      this.desktopCart = this.querySelector('[data-desktop-cart]');
      this.desktopCartItems = this.querySelector('[data-desktop-cart-items]');
      this.barrierVideos = [...this.querySelectorAll('[data-barrier-video]')];
      this.videoBreakpoint = window.matchMedia('(min-width: 768px)');
      this.reviewsBreakpoint = window.matchMedia('(min-width: 1024px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reviewsTrack = this.querySelector('[data-reviews-track]');
      this.reviewsShell = this.querySelector('[data-reviews-carousel]');
      this.reviewPause = this.querySelector('[data-review-pause]');
      this.syncReducedMotionUI = () => {
        if (!this.reviewPause) return;
        this.reviewPause.disabled = this.reducedMotion.matches;
        if (this.reducedMotion.matches) {
          this.reviewPause.setAttribute('aria-pressed', 'true');
          this.reviewPause.setAttribute('aria-label', 'Reviews autoplay off');
          this.reviewPause.textContent = 'Autoplay off';
          window.clearInterval(this.reviewsTimer);
        } else if (this.reviewPause.textContent === 'Autoplay off') {
          this.reviewPause.setAttribute('aria-pressed', 'false');
          this.reviewPause.setAttribute('aria-label', this.reviewPause.dataset.pauseLabel);
          this.reviewPause.textContent = this.reviewPause.dataset.pauseLabel.replace(' reviews', '');
          this.startReviewsAutoplay();
        }
        this.syncBarrierVideos();
      };
      this.syncCartSummaryInteractivity = () => {
        if (!this.cartSummary) return;
        if (this.videoBreakpoint.matches) {
          this.cartSummary.tabIndex = -1;
          this.cartSummary.setAttribute('aria-hidden', 'true');
          this.closeMiniCart();
        } else {
          this.cartSummary.removeAttribute('tabindex');
          this.cartSummary.removeAttribute('aria-hidden');
        }
      };
      this.syncBarrierVideos = () => {
        this.barrierVideos.forEach((video) => {
          const shouldPlay = (video.dataset.videoBreakpoint === 'desktop') === this.videoBreakpoint.matches;
          if (shouldPlay && !this.reducedMotion.matches) video.play().catch(() => {});
          else video.pause();
        });
      };
      this.videoBreakpoint.addEventListener?.('change', this.syncBarrierVideos);
      this.videoBreakpoint.addEventListener?.('change', this.syncCartSummaryInteractivity);
      this.syncReviewsForBreakpoint = () => {
        if (this.reviewsBreakpoint.matches || this.reducedMotion.matches) window.clearInterval(this.reviewsTimer);
        else if (this.reviewPause?.getAttribute('aria-pressed') !== 'true') this.startReviewsAutoplay();
      };
      this.reviewsBreakpoint.addEventListener?.('change', this.syncReviewsForBreakpoint);
      this.reducedMotion.addEventListener?.('change', this.syncReducedMotionUI);
      this.syncBarrierVideos();
      this.syncReducedMotionUI();
      this.syncCartSummaryInteractivity();
      this.syncStickyClearance = () => {
        if (!this.sticky || !window.matchMedia('(min-width: 1024px)').matches) {
          document.body.style.removeProperty('--cp-psf-sticky-clearance');
          return;
        }
        const clearance = Math.ceil(this.sticky.getBoundingClientRect().height) + 16;
        document.body.style.setProperty('--cp-psf-sticky-clearance', `${clearance}px`);
      };
      if ('ResizeObserver' in window && this.sticky) {
        this.stickyResizeObserver = new ResizeObserver(() => this.syncStickyClearance());
        this.stickyResizeObserver.observe(this.sticky);
      }
      window.addEventListener('resize', this.syncStickyClearance, { passive: true });
      this.handlePackChange = (event) => this.selectPack(event.currentTarget);
      this.packInputs.forEach((input) => input.addEventListener('change', this.handlePackChange));
      this.crossSells.forEach((button) => {
        const toggle = button.querySelector('[data-cross-sell-toggle]') || button;
        if (!button.querySelector('[data-scent-modal-open]')) {
          toggle.addEventListener('click', async () => {
            await this.toggleDesktopProduct(button);
          });
        }
      });
      this.querySelectorAll('[data-scent-modal-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.openScentModal(trigger));
      });
      this.querySelectorAll('[data-scent-modal]').forEach((modal) => {
        modal.querySelector('[data-scent-modal-close]')?.addEventListener('click', () => this.closeScentModal(modal));
        modal.addEventListener('click', (event) => {
          if (event.target === modal) this.closeScentModal(modal);
        });
        modal.addEventListener('keydown', (event) => this.handleScentModalKeydown(event, modal));
        modal.querySelectorAll('[data-deo-add]').forEach((button) => button.addEventListener('click', async () => {
          if (button.disabled) return;
          const added = await this.addDesktopVariant(button.dataset.deoAdd, 1, false);
          if (added) this.confirmScentAdded(button);
        }));
        modal.querySelector('[data-deo-add-both]')?.addEventListener('click', async (event) => {
          const button = event.currentTarget;
          const ids = button.dataset.deoAddBoth.split(',').filter(Boolean);
          const added = await this.addDesktopVariants(ids);
          if (added) this.confirmScentAdded(button);
        });
      });
      this.checkoutButton?.addEventListener('click', () => this.checkout());
      this.cartSummary?.addEventListener('click', () => {
        if (!this.videoBreakpoint.matches) this.toggleMiniCart();
      });
      this.miniCartClose?.addEventListener('click', () => {
        this.closeMiniCart();
        this.cartSummary?.focus();
      });
      this.miniCart?.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-line]');
        if (removeButton) this.decrementLine(removeButton.dataset.removeLine, removeButton.dataset.lineType);
      });
      this.packCta?.addEventListener('click', async () => {
        const pack = this.packInputs.find((input) => input.checked && !input.disabled && input.value);
        if (!pack) return;
        await this.addDesktopVariant(pack.value, 1, true);
        const label = this.packCta.querySelector('span');
        window.clearTimeout(this.packCtaResetTimer);
        label.textContent = this.dataset.itemsAddedLabel || 'ITEMS ADDED';
        this.packCta.classList.remove('is-added');
        void this.packCta.offsetWidth;
        this.packCta.classList.add('is-added');
        this.packCtaResetTimer = window.setTimeout(() => {
          label.textContent = this.packCta.dataset.defaultLabel;
          this.packCta.classList.remove('is-added');
        }, 1600);
        this.querySelector('[data-sticky-shipping]')?.focus?.();
      });
      this.querySelector('[data-desktop-cart-toggle]')?.addEventListener('click', () => this.setDesktopCartExpanded(this.desktopCart?.dataset.expanded !== 'true'));
      this.querySelector('[data-desktop-checkout]')?.addEventListener('click', () => window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`));
      this.querySelectorAll('[data-cart-scroll]').forEach((button) => button.addEventListener('click', () => {
        const direction = button.dataset.cartScroll === 'previous' ? -1 : 1;
        this.desktopCartItems?.scrollBy({ left: direction * 584, behavior: 'smooth' });
      }));
      this.desktopCartItems?.addEventListener('scroll', () => this.syncDesktopCartArrows(), { passive: true });
      this.desktopCartItems?.addEventListener('click', (event) => this.handleDesktopCartAction(event));
      this.querySelectorAll('[data-review-action]').forEach((button) => button.addEventListener('click', () => {
        this.pauseReviews();
        this.moveReview(button.dataset.reviewAction === 'previous' ? -1 : 1);
      }));
      this.reviewPause?.addEventListener('click', () => this.setReviewsPaused(this.reviewPause.getAttribute('aria-pressed') !== 'true'));
      this.reviewsTrack?.addEventListener('pointerdown', () => this.pauseReviews(), { passive: true });
      this.reviewsShell?.addEventListener('focusin', () => this.pauseReviews());
      this.footerAction?.addEventListener('click', () => {
        if ((this.realCart?.item_count || 0) > 0) {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
          return;
        }
        this.querySelector('.cp-psf__packs')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.packInputs.find((input) => !input.disabled)?.focus();
      });
      const defaultPack = this.packInputs.find((input) => input.dataset.defaultPack === 'true' && !input.disabled && input.value);
      this.selectPack(defaultPack || this.packInputs.find((input) => input.checked && !input.disabled && input.value));
      this.refreshDesktopCart();
      this.startReviewsAutoplay();

      // Non-essential page chrome must never prevent the staged funnel from initializing.
      try {
        this.initializeDrawerDismissal();
      } catch (error) {
        console.error('Protect Spray Funnel drawer setup failed', error);
      }
      try {
        this.initializeHeaderCartSuppression();
      } catch (error) {
        console.error('Protect Spray Funnel header setup failed', error);
      }
    }

    disconnectedCallback() {
      this.videoBreakpoint?.removeEventListener?.('change', this.syncBarrierVideos);
      this.videoBreakpoint?.removeEventListener?.('change', this.syncCartSummaryInteractivity);
      this.reviewsBreakpoint?.removeEventListener?.('change', this.syncReviewsForBreakpoint);
      this.reducedMotion?.removeEventListener?.('change', this.syncReducedMotionUI);
      window.clearInterval(this.reviewsTimer);
      this.stickyResizeObserver?.disconnect();
      window.removeEventListener('resize', this.syncStickyClearance);
      this.barrierVideos?.forEach((video) => video.pause());
      this.querySelectorAll('[data-scent-modal]:not([hidden])').forEach((modal) => { modal.hidden = true; });
      document.body.classList.remove('cp-psf-modal-open');
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleEscape);
      this.drawerDismissalInitialized = false;
      if (!document.querySelector('protect-spray-funnel')) {
        document.body.classList.remove('cp-funnel');
        document.body.style.removeProperty('--cp-psf-sticky-clearance');
        if (detachedHeaderCart?.parent?.isConnected) {
          detachedHeaderCart.parent.insertBefore(detachedHeaderCart.node, detachedHeaderCart.nextSibling?.isConnected ? detachedHeaderCart.nextSibling : null);
        }
        detachedHeaderCart = undefined;
      }
    }

    initializeDrawerDismissal() {
      if (this.drawerDismissalInitialized) return;
      this.drawerDismissalInitialized = true;
      this.handleDocumentClick = (event) => {
        const clickPath = event.composedPath?.() || [];
        const sticky = this.querySelector('[data-sticky]');
        const clickedSticky = clickPath.includes(sticky) || sticky?.contains(event.target);
        if (!this.miniCart?.hidden && !clickedSticky) this.closeMiniCart();
      };
      this.handleEscape = (event) => {
        if (event.key === 'Escape' && !this.miniCart?.hidden) {
          this.closeMiniCart();
          this.cartSummary?.focus();
        }
      };
      // Passive bubbling dismissal cannot cancel or swallow funnel taps on touch browsers.
      document.addEventListener('click', this.handleDocumentClick, { passive: true });
      document.addEventListener('keydown', this.handleEscape);
    }

    initializeHeaderCartSuppression() {
      if (detachedHeaderCart) return;
      const cart = document.querySelector('.t4s-site-nav__cart');
      if (!cart) return;
      detachedHeaderCart = { node: cart, parent: cart.parentNode, nextSibling: cart.nextSibling };
      cart.remove();
    }

    moveReview(direction) {
      if (!this.reviewsTrack || this.reviewsBreakpoint.matches) return;
      const card = this.reviewsTrack.querySelector('figure');
      if (!card) return;
      const step = card.getBoundingClientRect().width + 16;
      const max = this.reviewsTrack.scrollWidth - this.reviewsTrack.clientWidth;
      let target = this.reviewsTrack.scrollLeft + (direction * step);
      if (target > max - 2) target = 0;
      if (target < 0) target = max;
      this.reviewsTrack.scrollTo({ left: target, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
    startReviewsAutoplay() {
      window.clearInterval(this.reviewsTimer);
      if (!this.reviewsTrack || this.reducedMotion.matches || this.reviewsBreakpoint.matches || this.reviewPause?.getAttribute('aria-pressed') === 'true') return;
      this.reviewsTimer = window.setInterval(() => this.moveReview(1), 6000);
    }
    setReviewsPaused(paused) {
      if (!this.reviewPause) return;
      this.reviewPause.setAttribute('aria-pressed', String(paused));
      this.reviewPause.textContent = paused ? this.reviewPause.dataset.playLabel : this.reviewPause.dataset.pauseLabel;
      this.reviewPause.setAttribute('aria-label', paused ? this.reviewPause.dataset.playLabel : this.reviewPause.dataset.pauseLabel);
      if (paused) window.clearInterval(this.reviewsTimer);
      else this.startReviewsAutoplay();
    }
    pauseReviews() {
      if (this.reviewPause?.getAttribute('aria-pressed') !== 'true') this.setReviewsPaused(true);
    }

    selectPack(pack) {
      if (pack) {
        this.packInputs.forEach((input) => { input.checked = input === pack; });
        const marketPrice = this.marketPrice(pack);
        if (marketPrice > 0) pack.dataset.price = String(marketPrice);
      }
      const packPrice = this.querySelector('[data-pack-price]');
      if (packPrice) packPrice.textContent = pack ? this.money(Number(pack.dataset.price)) : '';
      if (this.packCta) this.packCta.disabled = !pack;
    }
    marketPrice(pack) {
      const attributePrice = Number(pack?.dataset.price);
      if (attributePrice > 0) return attributePrice;

      // In some Shopify Markets, variant.price is blank in data attributes even
      // though the market-localized money output beside it is populated.
      const priceText = pack?.closest('.cp-psf__pack')?.querySelector('[data-market-price]')?.textContent;
      if (!priceText) return 0;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: this.currency,
        currencyDisplay: 'narrowSymbol'
      });
      const parts = formatter.formatToParts(12345.6);
      const group = parts.find((part) => part.type === 'group')?.value;
      const decimal = parts.find((part) => part.type === 'decimal')?.value;
      let numeric = priceText.replace(/[^\d.,'’\s-]/g, '').trim();
      if (group) numeric = numeric.split(group).join('');
      numeric = numeric.replace(/[\s'’]/g, '');
      if (decimal && decimal !== '.') numeric = numeric.replace(decimal, '.');
      const amount = Number.parseFloat(numeric);
      const fractionDigits = formatter.resolvedOptions().maximumFractionDigits;
      return Number.isFinite(amount) ? Math.round(amount * (10 ** fractionDigits)) : 0;
    }
    openScentModal(trigger) {
      const modal = this.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
      if (!modal) return;
      this.scentModalTrigger = trigger;
      modal.hidden = false;
      document.body.classList.add('cp-psf-modal-open');
      modal.querySelector('button:not([disabled])')?.focus();
    }
    closeScentModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('cp-psf-modal-open');
      this.scentModalTrigger?.focus();
      this.scentModalTrigger = null;
    }
    handleScentModalKeydown(event, modal) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeScentModal(modal);
        return;
      }
      if (event.key !== 'Tab') return;
      const controls = [...modal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')];
      if (!controls.length) return;
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    confirmScentAdded(button) {
      const original = button.textContent;
      button.textContent = this.dataset.itemsAddedLabel || 'ITEMS ADDED';
      window.setTimeout(() => { button.textContent = original; }, 1600);
    }














  });
}
